import $ from 'jquery';

const initImageField = function (fieldId, previewId) {
  const field = document.getElementById(fieldId);
  if (field) {
    field.onchange = function () {
      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.
        const picturePreview = $('#' + previewId);
        $(picturePreview).attr('src', e.target.result);
        $(picturePreview).show();
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.files[0]);
    };
  }
};

export default initImageField;
